'use client'

import { CatalogDrawerFilter } from '@/features/catalog-shared/drawer-filter'
import { Filter, useFilter } from '@/features/catalog/filter'

type DrawerFilterProps = {
	productCount: number
}

export const DrawerFilter = ({ productCount }: DrawerFilterProps) => {
	const controller = useFilter()

	return (
		<CatalogDrawerFilter
			productCount={productCount}
			controller={controller}
			renderFilter={() => <Filter />}
			// Applied filters now live on the page (see Catalog screen), not inside the drawer.
			renderAppliedFilters={() => null}
		/>
	)
}
